import state from './moduleSessionState';
import mutations from './moduleSessionMutation';
import actions from './moduleSessionAction';
import getters from './moduleSessionGetter';

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters,
};
